module.exports = __webpack_public_path__ + "img/flag.6d5626b2.png";